import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=4849b049"
import script from "./BrandLogo.vue?vue&type=script&lang=ts"
export * from "./BrandLogo.vue?vue&type=script&lang=ts"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=4849b049&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports